export function createPageUrl(pageName) {
  // Convert CamelCase / PascalCase to kebab-case for URLs.
  // 'HowItWorks' → 'how-it-works', 'CustomCharacter' → 'custom-character'
  const kebab = pageName
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();
  return `/${kebab}`;
}

export function formatPrice(price, currency = '$') {
  return `${currency}${price}`;
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString();
}

export function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}
